export function getSellerContact(listing) {
  return {
    email: String(listing?.contact_email || listing?.user_email || '').trim(),
    phone: String(listing?.contact_phone || '').trim(),
  };
}

export function getPhoneHref(phone) {
  const normalized = String(phone || '').trim().replace(/[^\d+]/g, '');
  return normalized ? `tel:${normalized}` : '';
}

export function getExternalListingHref(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^\/\//.test(trimmed)) return `https:${trimmed}`;
  return `https://${trimmed.replace(/^\/+/, '')}`;
}

export function getListingMailtoHref(listing) {
  const { email } = getSellerContact(listing);
  if (!email) return '';

  const title = listing?.title || 'your dog listing';
  const subject = `Inquiry about ${title}`;
  const body = [
    `Hi ${listing?.user_name || 'there'},`,
    '',
    `I'm interested in your listing, "${title}" on DoggoHub.`,
    'Please let me know if this dog is still available.',
    '',
    'Thank you!',
  ].join('\n');

  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}